'use strict'

import createService from './createService'

const xref = createService('xref')
const quote = createService('quote')
const chart = createService('chart') // point to chartworks api

export default { xref, quote, chart }
